import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { CreateSupportBaseSubscriptionBody } from "@redotech/redo-model/support/billing/create-support-base-subscription-body";

export type GetSupportAIArgs = {
  type: "conversationReplySuggestion" | "conversationSummary";
  conversationId?: string;
  signal?: AbortSignal;
};

export type GetSupportAiResult = { text: string; cost: number };

/**
 * POST /support/ai/create-subscription
 */
export async function chargeForAiMessages(
  client: RedoMerchantClient,
  body: {},
  signal?: AbortSignal,
): Promise<{ confirmationUrl: string }> {
  const response = await client.client.post(
    "support/ai/create-subscription",
    body,
    { headers: client.authorization(), signal },
  );
  return response.data;
}

/**
 * POST /support/base/create-subscription
 */
export async function chargeForSupportBase(
  client: RedoMerchantClient,
  body: CreateSupportBaseSubscriptionBody,
  signal?: AbortSignal,
): Promise<{ confirmationUrl: string }> {
  const response = await client.client.post(
    "support/base/create-subscription",
    body,
    { headers: client.authorization(), signal },
  );
  return response.data;
}

/**
 * POST /support/create-ai-and-base-subscription
 */
export async function chargeForSupportAiAndBase(
  client: RedoMerchantClient,
  body: CreateSupportBaseSubscriptionBody,
  signal?: AbortSignal,
): Promise<{ confirmationUrl?: string; success?: boolean }> {
  const response = await client.client.post(
    "support/create-ai-and-base-subscription",
    body,
    { headers: client.authorization(), signal },
  );
  return response.data;
}

export async function getSupportAISummary(
  client: RedoMerchantClient,
  { type, conversationId, signal }: GetSupportAIArgs,
): Promise<GetSupportAiResult | "error"> {
  try {
    const response = await client.client.post(
      "support/ai/summary",
      { type, conversationId },
      { headers: client.authorization(), signal, timeout: 15_000 },
    );
    return response.data;
  } catch {
    return "error";
  }
}
